import React from 'react'

const EverythingElse = () => {
  return (
    <div>
      Everything
    </div>
  )
}

export default EverythingElse

